import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class ShiftPlanService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 512 */
    public getPlans(): Promise<Item[]> { return this.datatask.Post(512, {}); }
    /** @datatask 513 */
    public async getPlan(params: ShiftPlanParams): Promise<ShiftPlanGet> { return (await this.datatask.Post(513, params))[0]; }
    /** @datatask 514 */
    public async savePlan(page: ShiftPlanGet): Promise<void> { await this.datatask.Post(514, page); }
    /** @datatask 515 */
    public async deletePlan(params: ShiftPlanParams): Promise<void> { await this.datatask.Post(515, params); }
}
export interface ShiftPlanParams { shiftplan_id: string; }
export interface ShiftPlanGet extends ShiftPlanParams { shiftplan_description: string; is_new: '0' | '1'; }
